export const trlFieldDefaultValue = () => '-';

export const TrlFieldDefaultValue = () => '-';
